import { PayloadAction } from '@reduxjs/toolkit';

import { AppState, SlotLayoutBuilderState } from 'editor/src/store/app/types';

const openSlotLayoutBuilderReducer = (state: AppState, { payload }: PayloadAction<SlotLayoutBuilderState>) => {
  state.slotLayoutBuilder = payload;
};

export default openSlotLayoutBuilderReducer;
